import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'cs',
  Pagination: {
    items_per_page: '/ strana',
    jump_to: 'Přejít',
    jump_to_confirm: 'potvrdit',
    page: '',
    prev_page: 'Předchozí strana',
    next_page: 'Následující strana',
    prev_5: 'Předchozích 5 stran',
    next_5: 'Následujících 5 stran',
    prev_3: 'Předchozí 3 strany',
    next_3: 'Následující 3 strany',
  },
  DatePicker: {
    lang: {
      placeholder: 'Vybrat datum',
      rangePlaceholder: [
        'Od',
        'Do',
      ],
      locale: 'cs_CZ',
      today: 'Dnes',
      now: 'Nyní',
      backToToday: 'Zpět na dnešek',
      ok: 'Ok',
      clear: 'Vymazat',
      month: 'Měsíc',
      year: 'Rok',
      timeSelect: 'Vybrat čas',
      dateSelect: 'Vybrat datum',
      monthSelect: 'Vyberte měsíc',
      yearSelect: 'Vyberte rok',
      decadeSelect: 'Vyberte dekádu',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Předchozí měsíc (PageUp)',
      nextMonth: 'Následující (PageDown)',
      previousYear: 'Předchozí rok (Control + left)',
      nextYear: 'Následující rok (Control + right)',
      previousDecade: 'Předchozí dekáda',
      nextDecade: 'Následující dekáda',
      previousCentury: 'Předchozí století',
      nextCentury: 'Následující století',
    },
    timePickerLocale: {
      placeholder: 'Vybrat čas',
    },
  },
  TimePicker: {
    placeholder: 'Vybrat čas',
  },
  Calendar: {
    lang: {
      placeholder: 'Vybrat datum',
      rangePlaceholder: [
        'Od',
        'Do',
      ],
      locale: 'cs_CZ',
      today: 'Dnes',
      now: 'Nyní',
      backToToday: 'Zpět na dnešek',
      ok: 'Ok',
      clear: 'Vymazat',
      month: 'Měsíc',
      year: 'Rok',
      timeSelect: 'Vybrat čas',
      dateSelect: 'Vybrat datum',
      monthSelect: 'Vyberte měsíc',
      yearSelect: 'Vyberte rok',
      decadeSelect: 'Vyberte dekádu',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Předchozí měsíc (PageUp)',
      nextMonth: 'Následující (PageDown)',
      previousYear: 'Předchozí rok (Control + left)',
      nextYear: 'Následující rok (Control + right)',
      previousDecade: 'Předchozí dekáda',
      nextDecade: 'Následující dekáda',
      previousCentury: 'Předchozí století',
      nextCentury: 'Následující století',
    },
    timePickerLocale: {
      placeholder: 'Vybrat čas',
    },
  },
  global: {
    placeholder: 'Prosím vyber',
  },
  Table: {
    filterTitle: 'Filtr',
    filterConfirm: 'Potvrdit',
    filterReset: 'Obnovit',
    filterEmptyText: 'Žádné filtry',
    selectAll: 'Vybrat všechny řádky na současné stránce',
    selectInvert: 'Invertovat výběr na současné stránce',
    selectionAll: 'Vybrat všechny řádky',
    sortTitle: 'Řadit',
    expand: 'Rozbalit řádek',
    collapse: 'Zabalit řádek',
    triggerDesc: 'Klikni pro sestupné řazení',
    triggerAsc: 'Klikni pro vzestupné řazení',
    cancelSort: 'Klikni pro zrušení řazení',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Storno',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Storno',
  },
  Transfer: {
    searchPlaceholder: 'Vyhledávání',
    itemUnit: 'položka',
    itemsUnit: 'položek',
  },
  Upload: {
    uploading: 'Nahrávání...',
    removeFile: 'Odstranit soubor',
    uploadError: 'Chyba při nahrávání',
    previewFile: 'Zobrazit soubor',
    downloadFile: 'Stáhnout soubor',
  },
  Empty: {
    description: 'Žádná data',
  },
};

export default localeValues;
